
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import DivSpan from '@/components/DivSpan';
import baseInfo from '../view/base-info';
import contact from '../view/contact';
import bankInfo from '../view/bank-info';
import manageInfo from '../view/manage-info';
import procureOrgan from '../view/procure-organ';
import supplyCategory from '../view/supply-category';
import qualificationInfo from '../view/qualification-info';
import supOverview from '../view/sup-overview';
import supplierDynamicFormValue from '@/components/supplier-dynamic-form-value';
export default {
name: "new-sup-approval",
directives: {
TransferDom
},
props:['dataId'],
components: {
Grid,
GridItem,
DivSpan,
Popup,
supOverview,
baseInfo,
contact,
bankInfo,
manageInfo,
procureOrgan,
supplyCategory,
qualificationInfo,
supplierDynamicFormValue
},
data(){
return{
supplierId: null,
supplierDetail:{},
show: false,
moduleList: [],
allList: [
{icon:"icon-ability",color:'#5BAAF9',module:'overview'},
{icon:"icon-information",color: "#37CC68",module:'BASIC_INFO'},
{icon:"icon-trophy",color:"#FFBF4F",module:'RESERVED_1'},
{icon: "icon-contact", color:"#5BAAF9",module:'SUP_CONTACT'},
{icon:"icon-bar-chart",color:"#37CC68",module:'RESERVED_2'},
{icon: "icon-bank_account",color:"#FFBF4F",module:'SUP_BANK'},
{icon:"icon-adress",color:"#5BAAF9",module:'RESERVED_3'},
{icon:"icon-file",color:"#37CC68",module:'SAP_ECC'},
{icon:"icon-field",color:"#FFBF4F",module:'KING_DEE'},
{icon:"icon-document",color:"#5BAAF9",module:'RESERVED_4'},
{icon:"icon-fujian",color:"#37CC68",module:'RESERVED_5'},
{icon:"icon-detal",color:"#FFBF4F",module:'RESERVED_6'},
{icon: "icon-manege", color:"#5BAAF9",module:'MANAGE_INFO'},
{icon:"icon-gongsixinxi",color:"#37CC68",module:'RESERVED_7'},
{icon:"icon-organize",color:"#FFBF4F",module:'SUP_ORGSTATUS'},
{icon:"icon-information",color:"#37CC68",module:'RESERVED_8'},
{icon:"icon-default",color:"#FFBF4F",module:'SUP_QUAL'},
{icon:"icon-variety",color:"#5BAAF9",module:'SUP_SUPPLY_CAT'},
],
showModule:'BASIC_INFO',
reserved_1Code:'',
reserved_2Code:'',
reserved_3Code:'',
reserved_4Code:'',
reserved_5Code:'',
reserved_6Code:'',
reserved_7Code:'',
reserved_8Code:'',
sap_eccCode:'',
kingDeeCode:'',
questionaryId:null,
purorgList:[]
}
},
methods:{
showMore() {
this.show = true;
},

getModuleList() {
debugger
let paramObj = {'supplierId': this.supplierId};
let paramStr = JSON.stringify(paramObj);
let menuCode = '';
if (this.$route.query.id === 'mine') {
menuCode = 'SUPPLIER_OWN';
} else {
menuCode = 'SUPPLIER'
}
this.$loadingShow();
this.$get('api/config-menu/find-by-code', {code: menuCode, param: paramStr}).then((res) => {
this.moduleList = [];
if(res && res[1] && res[1].children){
res[1].children.forEach((item) => {
let obj = JSON.parse(item.moduleName);
let str;
for(let key in obj){
str = key;
}
let arr = this.allList.filter((item) => {
return item.module === str;
});
if(arr[0]){
arr[0].name = item.title;
this.moduleList.push(arr[0]);
}
})
}
let obj = {icon:"icon-liucheng",color:"rgb(254, 108, 112)",module:'flow',name:'流程信息'};
this.moduleList.push(obj);
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
});
},

getSupplier(){
this.$loadingShow();
this.$get(`api/supplier/get-module-all-module?supplierId=${this.supplierId}`).then((res) => {
this.supplierDetail = res;
this.questionaryId = res.questionaryId;
for(let i=0;i<res.supModuleStatus.length;i++){
if (res.supModuleStatus[i].moduleName === 'BASIC_INFO') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newValueData){
this.supplierDetail.supBasicInfo = JSON.parse(res.supModuleStatus[i].modifyContent).newValueData;
if(this.supplierDetail.supBasicInfo.purorgids){
let list = [];
this.supplierDetail.supBasicInfo.purorgids.forEach((item) => {
for(let i=0;i<this.purorgList.length;i++){
if(item === this.purorgList[i].id){
list.push(this.purorgList[i].purorgName);
break;
}
}
});
this.supplierDetail.supBasicInfo.purorgNames = list.join(',');
}
}
continue;
}
if (res.supModuleStatus[i].moduleName === 'MANAGE_INFO') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newValueData){
this.supplierDetail.supManageInfo = JSON.parse(res.supModuleStatus[i].modifyContent).newValueData;
}
continue;
}
if (res.supModuleStatus[i].moduleName === 'SUP_CONTACT') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newList){
this.supplierDetail.supContactList = JSON.parse(res.supModuleStatus[i].modifyContent).newList;
}
continue;
}
if (res.supModuleStatus[i].moduleName === 'SUP_BANK') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newList){
this.supplierDetail.supBankList = JSON.parse(res.supModuleStatus[i].modifyContent).newList;
}
}
if (res.supModuleStatus[i].moduleName === 'RESERVED_1') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newValueData){
this.supplierDetail.reserved_1 = JSON.parse(res.supModuleStatus[i].modifyContent).newValueData;
}
continue;
}
if (res.supModuleStatus[i].moduleName === 'RESERVED_2') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newValueData){
this.supplierDetail.reserved_2 = JSON.parse(res.supModuleStatus[i].modifyContent).newValueData;
}
continue;
}
if (res.supModuleStatus[i].moduleName === 'RESERVED_3') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newValueData){
this.supplierDetail.reserved_3 = JSON.parse(res.supModuleStatus[i].modifyContent).newValueData;
}
continue;
}
if (res.supModuleStatus[i].moduleName === 'RESERVED_4') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newValueData){
this.supplierDetail.reserved_4 = JSON.parse(res.supModuleStatus[i].modifyContent).newValueData;
}
continue;
}
if (res.supModuleStatus[i].moduleName === 'RESERVED_5') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newValueData){
this.supplierDetail.reserved_5 = JSON.parse(res.supModuleStatus[i].modifyContent).newValueData;
}
continue;
}
if (res.supModuleStatus[i].moduleName === 'RESERVED_6') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newValueData){
this.supplierDetail.reserved_6 = JSON.parse(res.supModuleStatus[i].modifyContent).newValueData;
}
continue;
}
if (res.supModuleStatus[i].moduleName === 'RESERVED_7') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newValueData){
this.supplierDetail.reserved_7 = JSON.parse(res.supModuleStatus[i].modifyContent).newValueData;
}
continue;
}
if (res.supModuleStatus[i].moduleName === 'RESERVED_8') {
if(res.supModuleStatus[i].modifyContent && JSON.parse(res.supModuleStatus[i].modifyContent).newValueData){
this.supplierDetail.reserved_8 = JSON.parse(res.supModuleStatus[i].modifyContent).newValueData;
}
}
}
this.getStatus();
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
})
},
getData() {
this.$loadingShow();
this.$get(`api/sup-modify/${this.dataId}`).then((res) => {
if(res){
this.supplierId = res.supplier.id;
this.getModuleList();
this.getSupplier();
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
});
},
changeShow(str){
if(str === 'flow'){
this.$emit('changeFlowInfo', true);
}else{
this.$emit('changeFlowInfo', false);
}
this.showModule = str;
this.show = false;
},
getStatus() {
if (this.questionaryId) {
for(let i=1;i<9;i++){
let param = {
questionaryId: this.questionaryId,
supplierId:this.supplierId,
moduleName:`RESERVED_${i}`
};
this.$get('api/supplier/get-dynamic-form',param).then((res) => {
this[`reserved_${i}Code`] = res.dynamicFormCode;
});
}
let param1 = {
questionaryId: this.questionaryId,
supplierId:this.supplierId,
moduleName:`SAP_ECC`
};
this.$get('api/supplier/get-dynamic-form',param1).then((res) => {
this[`sap_eccCode`] = res.dynamicFormCode;
});
let param2 = {
questionaryId: this.questionaryId,
supplierId:this.supplierId,
moduleName:`KING_DEE`
};
this.$get('api/supplier/get-dynamic-form',param2).then((res) => {
this[`kingDeeCode`] = res.dynamicFormCode;
});
}
},
valid(){
return true;
},
formData(){
return this.supplierDetail;
}
},
mounted(){
this.getData();
this.$get('api/purorg/all').then((data) => {
if(data){
this.purorgList = data;
}
});
}
}



// WEBPACK FOOTER //
// ./src/page/supplier/approval/new-sup-approval.vue